<template>
  <div id="app" class="theme-0">
    <router-view />
  </div>
</template>
<script>
    export default{
        name: 'app',
        data(){
            return{
            }
        },
        created(){
        },
        methods:{

        },
        computed:{
            skin(){
                return this.$store.getters.skin
            },
        },
        watch:{
            $route(newVal){
                //if the zendesk chat is active remove it
                let zendeskElements = document.getElementsByClassName('zopim')
                if(newVal.name !== 'eap'){
                    for(let i =0 ; i < zendeskElements.length; i++){
                        zendeskElements[i].style.display = "none"
                    }
                }else if(zendeskElements.length > 0){
                    zendeskElements[0].style.display = "block"
                }
            }
        }
    }
</script>
<style lang="less">
  @import "assets/_theme-0";
  html {
    font-size: 10px;
    @media only screen and (max-width: 576px){
      font-size: 9px;
    }
  }
  @font-face {
    font-family: 'ff-cocon-web-pro';
    src: url(./assets/fonts/CoconPro-Regular.woff);
  }
  @font-face {
    font-family: 'ff-sari-web-bold';
    src: url(./assets/fonts/ufonts.com_sari-bold.woff);
  }
  @font-face {
    font-family: 'ff-sari-web-medium';
    src: url(./assets/fonts/ufonts.com_sari-medium.woff);
  }
  @font-face {
    font-family: 'ff-sari-web-regular';
    src: url(./assets/fonts/ufonts.com_sari-regular.woff);
  }
  @font-face {
    font-family: "FilsonProBlack";
    src: url("assets/fonts/FilsonProBlack.ttf");
    src: url("assets/fonts/FilsonProBlack.woff");
    font-weight: normal;
    font-style: normal;
  }

  @font-face {
    font-family: "FilsonProBold";
    src: url("assets/fonts/FilsonProBold.ttf");
    src: url("assets/fonts/FilsonProBold.woff");
    font-weight: normal;
    font-style: normal;
  }

  @font-face {
    font-family: "FilsonProBook";
    src: url("assets/fonts/FilsonProBook.ttf");
    src: url("assets/fonts/FilsonProBook.woff");
    font-weight: normal;
    font-style: normal;
  }

  @font-face {
    font-family: "FilsonProLight";
    src: url("assets/fonts/FilsonProLight.ttf");
    src: url("assets/fonts/FilsonProLight.woff");
    font-weight: normal;
    font-style: normal;
  }
  #app {
    height: 100vh;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
    position: relative;
    overflow-x: hidden;
    a {
      cursor: pointer;
    }
    h2 {
      font-family: ff-cocon-web-pro;
      font-size: 40px;
      color: #3a4961;
      text-align: center;
      margin-bottom: 20px;
    }
    p {
      color: #394961;
    }
    .btn {
      border-radius: 60px;
      font-size: 1.6rem;
      line-height: 1;
      letter-spacing: 0.2rem;
      border-width: 0;
      &.border-white{
        border-width: 1px;
        border-color: #fff;
        &.active{
          border-width: 0;
        }
      }
      &:focus{
        box-shadow: none;
      }
    }
    .btn-purple {
      background-color: #014D71;
      color: #fff;
    }
    input[type=email]::-ms-clear,input[type=text]::-ms-clear  { display: none; }
    input{
      // set as important as Filson Pro looks broken in input fields
      //TODO:: Discuss font options with Niamh
      font-family: 'Open Sans', sans-serif !important;
    }
    .col-xs-5ths,
    .col-sm-5ths,
    .col-md-5ths,
    .col-lg-5ths {
      position: relative;
      min-height: 1px;
    }

    .col-xs-5ths {
      width: 20%;
      float: left;
    }

    @media (min-width: 768px) {
      .col-sm-5ths {
        width: 20%;
        float: left;
      }
    }

    @media (min-width: 992px) {
      .col-md-5ths {
        width: 20%;
        float: left;
      }
    }

    @media (min-width: 1200px) {
      .col-lg-5ths {
        width: 20%;
        float: left;
      }
    }
  }
</style>
